import { SelectArrowButton } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { PaperFormat } from '../../../api/gql/graphql';

interface PaperButtonProps {
  selectPaperFormat: (format: PaperFormat) => void;
  paperType: PaperFormat;
}

export function PaperButton({
  paperType,
  selectPaperFormat,
}: PaperButtonProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <SelectArrowButton
      data-cy="PaperSelectArrowButton"
      onClick={() => {
        selectPaperFormat(paperType);
      }}
      text={t(
        paperType === PaperFormat.A4
          ? 'paperSize.sizeA4'
          : 'paperSize.sizeUsLetter',
      )}
      description={t(
        paperType === PaperFormat.A4
          ? 'paperSize.measurementA4'
          : 'paperSize.measurementLetter',
      )}
      altText={t('imageAlt.arrowIcon')}
    />
  );
}
